<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade forgetpassword-modal"
    id="applyCouponModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title text-center" id="exampleModalLongTitle">
            كوبون Academia
          </h5>
        </div>
        <div class="modal-body">
          <div class="support-box">
            <img
              class="support-img text-center"
              src="assets/images/coupon.png"
              alt=""
            />
          </div>
          <h4 class="mb-2 text-center support-text">أدخل أدناه رمز الكوبون</h4>
          <form class="form-horizontal" action="home.html">
            <div style="min-height: 10px">
              <span
                id="error-message"
                style="color: red; display: none; text-align: right"
              >
                يرجى تحديد رقم الهاتف يرجى تحديد رقم الهاتف يرجى تحديد رقم
                الهاتف يرجى تحديد رقم الهاتف
              </span>
              <div
                id="cert-btn"
                style="text-align: center; display: none"
              ></div>
            </div>

            <div class="row" dir="rtl">
              <div class="col-md-12">
                <div class="form-group form-group-custom mb-4" dir="rtl">
                  <label for="name">رمز الكوبون </label>
                  <input
                    type="text"
                    class="form-control"
                    id="code"
                    placeholder="XXXXXXXXX"
                    v-model="code"
                  />
                </div>

                <div class="mt-4">
                  <button
                    style="width: 100%"
                    ref="applyCouponBtn"
                    id="applyCouponBtn"
                    @click="applyCoupon"
                    class="p-3 btn btn-success btn-block waves-effect waves-light"
                    type="button"
                  >
                    تطبيق <i class="fa fa-check-circle"></i>
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary"
            data-bs-dismiss="modal"
          >
            تراجع
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { applyCoupon, removeCoupon } from "@/utils/cart";

export default {
  name: "Academia",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      code: "",
      isLoading: false,
    };
  },
  mounted() {},
  methods: {
    applyCoupon() {
      const couponCode = this.code.trim(); // Trim to remove any leading/trailing spaces
      const button = this.$refs.applyCouponBtn;
      const token = this.token;

      if (!couponCode) {
        // Show an error message if the coupon code is empty
        Swal.fire({
          icon: "error",
          title: "خطأ",
          text: "يرجى إدخال رمز الكوبون",
          confirmButtonText: "حسناً",
        });
        return;
      }

      // Proceed with applying the coupon
      applyCoupon(couponCode, $(button));
    },
    removeCoupon() {
      removeCoupon();
    },
  },
};
</script>

<style scoped>
/* ========== Modal Content ========== */
.modal-content {
  border-radius: 24px !important;
  overflow: hidden;
  border: none;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.15);
}

/* ========== Modal Header ========== */
.modal-header {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%);
  padding: 24px;
  border: none;
  position: relative;
  overflow: hidden;
}
.modal-header::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100%;
  height: 200%;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.1) 0%,
    transparent 70%
  );
  animation: headerShine 3s ease-in-out infinite;
}
@keyframes headerShine {
  0%,
  100% {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
}
.modal-title {
  color: #fff !important;
  font-weight: 700;
  font-size: 1.3rem;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}
.modal-title::before {
  content: "🎁";
  font-size: 1.5rem;
  animation: giftBounce 2s ease-in-out infinite;
}
@keyframes giftBounce {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-5px);
  }
}

/* ========== Modal Body ========== */
.modal-body {
  background: linear-gradient(145deg, #f8fffe 0%, #ffffff 100%);
  padding: 30px;
}

/* ========== Support Box ========== */
.support-box {
  text-align: center;
  margin-bottom: 20px;
}
.support-img {
  width: 120px;
  height: auto;
  filter: drop-shadow(0 8px 20px rgba(0, 196, 68, 0.2));
  animation: couponFloat 3s ease-in-out infinite;
}
@keyframes couponFloat {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-10px) rotate(3deg);
  }
}

/* ========== Support Text ========== */
.support-text {
  color: #1a1a2e;
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 24px;
}

/* ========== Form ========== */
.form-group-custom {
  margin-bottom: 20px;
}
.form-group-custom label {
  color: #00a43c;
  font-weight: 600;
  font-size: 0.95rem;
  margin-bottom: 10px;
  display: block;
}
.form-group-custom .form-control {
  border: 2px solid rgba(0, 196, 68, 0.2);
  border-radius: 14px;
  padding: 16px 20px;
  font-size: 1.1rem;
  font-weight: 600;
  text-align: center;
  letter-spacing: 3px;
  background: linear-gradient(145deg, #f8fffe 0%, #f0fff5 100%);
  transition: all 0.3s ease;
}
.form-group-custom .form-control:focus {
  border-color: #00c444;
  box-shadow: 0 0 0 4px rgba(0, 196, 68, 0.15);
  background: #fff;
}
.form-group-custom .form-control::placeholder {
  color: #aaa;
  letter-spacing: 5px;
}

/* ========== Apply Button ========== */
.btn-success {
  background: linear-gradient(135deg, #00c444 0%, #00a43c 100%) !important;
  border: none !important;
  border-radius: 14px !important;
  padding: 16px 24px !important;
  font-weight: 700 !important;
  font-size: 1.05rem !important;
  box-shadow: 0 8px 25px rgba(0, 196, 68, 0.3) !important;
  transition: all 0.3s ease !important;
  position: relative;
  overflow: hidden;
}
.btn-success::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.2),
    transparent
  );
  transition: left 0.5s ease;
}
.btn-success:hover::before {
  left: 100%;
}
.btn-success:hover {
  transform: translateY(-3px) !important;
  box-shadow: 0 12px 35px rgba(0, 196, 68, 0.4) !important;
}
.btn-success i {
  margin-right: 8px;
}

/* ========== Modal Footer ========== */
.modal-footer {
  background: linear-gradient(145deg, #f8fffe 0%, #ffffff 100%);
  border-top: 1px solid rgba(0, 196, 68, 0.1);
  padding: 16px 24px;
}
.modal-footer .btn-secondary {
  background: linear-gradient(135deg, #6c757d 0%, #5a6268 100%) !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  transition: all 0.3s ease !important;
}
.modal-footer .btn-secondary:hover {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(108, 117, 125, 0.3) !important;
}

/* ========== Error Message ========== */
#error-message {
  background: linear-gradient(135deg, #fff5f5 0%, #ffe8e8 100%);
  border: 1px solid rgba(220, 53, 69, 0.2);
  border-radius: 12px;
  padding: 12px 16px;
  font-size: 0.9rem;
}

/* ========== Legacy Styles ========== */
.icon-img {
  margin-bottom: 10px;
  width: 100px;
}

#academia-code {
  text-align: center;
  border: 0px;
  background: #ededed;
  height: unset;
}

.btn-charge {
  padding: 10px 50px;
  font-weight: 600;
  background: rgb(0, 196, 68);
}

/* ========== DARK MODE ========== */
[data-bs-theme="dark"] .modal-content,
[data-theme="dark"] .modal-content,
.dark .modal-content {
  background: #242526;
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] .modal-body,
[data-theme="dark"] .modal-body,
.dark .modal-body {
  background: linear-gradient(145deg, #1a1b1d 0%, #242526 100%);
}

[data-bs-theme="dark"] .support-text,
[data-theme="dark"] .support-text,
.dark .support-text {
  color: #e4e6eb;
}

[data-bs-theme="dark"] .form-group-custom label,
[data-theme="dark"] .form-group-custom label,
.dark .form-group-custom label {
  color: #00e050;
}

[data-bs-theme="dark"] .form-group-custom .form-control,
[data-theme="dark"] .form-group-custom .form-control,
.dark .form-group-custom .form-control {
  background: linear-gradient(145deg, #2d2e30 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.25);
  color: #e4e6eb;
}
[data-bs-theme="dark"] .form-group-custom .form-control:focus,
[data-theme="dark"] .form-group-custom .form-control:focus,
.dark .form-group-custom .form-control:focus {
  background: #2d2e30;
  border-color: #00e050;
  box-shadow: 0 0 0 4px rgba(0, 196, 68, 0.2);
}
[data-bs-theme="dark"] .form-group-custom .form-control::placeholder,
[data-theme="dark"] .form-group-custom .form-control::placeholder,
.dark .form-group-custom .form-control::placeholder {
  color: #666;
}

[data-bs-theme="dark"] .modal-footer,
[data-theme="dark"] .modal-footer,
.dark .modal-footer {
  background: linear-gradient(145deg, #1a1b1d 0%, #242526 100%);
  border-color: rgba(0, 196, 68, 0.15);
}

[data-bs-theme="dark"] #error-message,
[data-theme="dark"] #error-message,
.dark #error-message {
  background: linear-gradient(135deg, #3d2020 0%, #4a1a1a 100%);
  border-color: rgba(220, 53, 69, 0.35);
  color: #ff8b8b;
}
</style>
